import {Transport} from "./Transport";
import {Locale} from "./Locale";
import "./ConsentToast.css";

const BX = (window.BX || top.BX);

export class ConsentToast {

	static defaults = {
		acceptElement: '[data-action="accept"]',
		detailsElement: '[data-action="details"]',
		transitionDuration: 300,
		cookieExpires: 60 * 60 * 24 * 365,
		config: null,
		transport: {},
	};

	constructor(element: HTMLElement, options: Object) {
		this.el = element;
		this.options = Object.assign({}, ConsentToast.defaults, this.el.dataset, options);
		this.locale = new Locale(this.options.locale);
		this.transport = new Transport(this.options.config, this.options.transport);
	}

	start(): void {
		if (this.alreadyGiven()) {
			this.remove();
			return;
		}

		this.show();
	}

	bind(): void {
		this.handleAccept(true);
	}

	unbind(): void {
		this.handleAccept(false);
	}

	handleAccept(dir: boolean): void {
		const button = this.el.querySelector(this.options.acceptElement);

		button[dir ? 'addEventListener' : 'removeEventListener']('click', this.onAccept);
	}

	handleDetails(dir: boolean): void {
		const button = this.el.querySelector(this.options.detailsElement);

		button[dir ? 'addEventListener' : 'removeEventListener']('click', this.onDetails);
	}

	onAccept = (evt: MouseEvent): void => {
		const button: HTMLButtonElement = evt.currentTarget;

		if (button.disabled) { return; }
		button.disabled = true;

		this.hide();
		this.accept();
	}

	remove(): void {
		this.el.remove();
		this.el = null;
	}

	show(): void {
		this.bind();
		this.animateIn();
	}

	hide(): void {
		this.unbind();
		this.animateOut().then(() => { this.remove(); });
	}

	animateIn(): void {
		this.wrapTransition(() => {
			this.el.classList.add('is--active');
		});
	}

	animateOut(): Promise<void> {
		return this.wrapTransition(() => {
			this.el.classList.remove('is--active');
		});
	}

	wrapTransition(body: () => {}): void {
		return new Promise((resolve) => {
			this.el.classList.add('transition--process');

			requestAnimationFrame(() => {
				body();

				setTimeout(() => {
					this.el.classList.remove('transition--process');
					resolve();
				}, this.options.transitionDuration);
			});
		});
	}

	async accept() {
		if (!this.options.config.autoSave) {
			this.markAccept();
			return;
		}

		await this.transport.saveConsent();
		this.markAccept();
	}

	alreadyGiven() {
		return BX.getCookie('COOKIE_CONSENT') === 'Y' || localStorage.getItem('COOKIE_CONSENT') === 'N';
	}

	markAccept(): void {
		BX.setCookie('COOKIE_CONSENT', 'Y', {
			expires: this.options.cookieExpires,
			path: '/'
		});
	}
}